module.exports = __webpack_public_path__ + "static/media/dropshipping.6391293f.svg";